export default __webpack_public_path__ + "static/media/A4PosterRight.5ffaad01.png";